var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2229_24689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#F7D4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2754 31H26.2754V28H29.2754V26H26.2754V23H24.2754V26H21.2754V28H24.2754V31ZM19.2754 34C18.7254 34 18.2546 33.8042 17.8629 33.4125C17.4712 33.0208 17.2754 32.55 17.2754 32V22C17.2754 21.45 17.4712 20.9792 17.8629 20.5875C18.2546 20.1958 18.7254 20 19.2754 20H20.2754V18C20.2754 16.6167 20.7629 15.4375 21.7379 14.4625C22.7129 13.4875 23.8921 13 25.2754 13C26.6587 13 27.8379 13.4875 28.8129 14.4625C29.7879 15.4375 30.2754 16.6167 30.2754 18V20H31.2754C31.8254 20 32.2962 20.1958 32.6879 20.5875C33.0796 20.9792 33.2754 21.45 33.2754 22V32C33.2754 32.55 33.0796 33.0208 32.6879 33.4125C32.2962 33.8042 31.8254 34 31.2754 34H19.2754ZM22.2754 20H28.2754V18C28.2754 17.1667 27.9837 16.4583 27.4004 15.875C26.8171 15.2917 26.1087 15 25.2754 15C24.4421 15 23.7337 15.2917 23.1504 15.875C22.5671 16.4583 22.2754 17.1667 22.2754 18V20Z",
    fill: "#D32778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2229_24689",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_24689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2229_24689",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.81919fe0de476f21a38d63d0adac68fe.svg";
export { ForwardRef as ReactComponent };